import { render, staticRenderFns } from "./FreeAlertModal.vue?vue&type=template&id=61152f92&scoped=true"
import script from "./FreeAlertModal.vue?vue&type=script&lang=js"
export * from "./FreeAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61152f92",
  null
  
)

export default component.exports